import React, { FC, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import {
  Dialog, Typography, Box,
} from '@material-ui/core';

interface CatalogPreviewDialogProps {
  open: boolean;
  url: string;
  onCancel: () => void;
}

const CatalogPreviewDialog: FC<CatalogPreviewDialogProps> = (props) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  const [docNumPages, setDocNumPages] = useState(0);
  const { open, url, onCancel } = props;

  return (
    <Dialog onClose={() => onCancel()} aria-labelledby="simple-dialog-title" open={open}>
      <Typography variant="h3" style={{ padding: '1rem' }}>Catalog</Typography>
      <Box style={{ paddingLeft: '2rem', paddingRight: '2rem' }}>
        <Document
          file={url}
          onLoadSuccess={(document) => {
            const { numPages } = document;
            setDocNumPages(numPages);
          }}
        >
          {Array.from(
            new Array(docNumPages),
            (_, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
              />
            ),
          )}
        </Document>
      </Box>
      <Box style={{ padding: '1rem' }} />
    </Dialog>
  );
};

export default CatalogPreviewDialog;
